module.exports = __webpack_public_path__ + "img/40_38_051_520.5ee48d67.jpg";